import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Map, Globe2 } from 'lucide-react';
export function PlatformGlobal() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-surface-muted rounded-3xl my-12" data-id="element-331">
      <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-332">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-333">
          Global Platform
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark mb-6" data-id="element-334">
          Designed for local deployment and global scale
        </h2>
        <p className="text-lg text-ink-muted leading-relaxed" data-id="element-335">
          The SyNeural platform is designed to work across local, regional,
          national, and international contexts. This makes the platform relevant
          not only as an individual development tool, but as a broader strategic
          infrastructure for human capability, civic resilience, and governance
          quality.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-336">
        {/* Municipal */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col bg-white p-8 rounded-xl border border-line shadow-sm" data-id="element-337">
          <div className="flex items-center gap-3 mb-4 border-b border-line pb-4" data-id="element-338">
            <MapPin size={24} className="text-navy-light" data-id="element-339" />
            <h3 className="text-xl font-heading font-bold text-ink-dark" data-id="element-340">
              Municipal
            </h3>
          </div>
          <p className="text-ink-muted leading-relaxed" data-id="element-341">
            Identify community-level bottlenecks such as weak youth pathways,
            misinformation vulnerability, or low workforce readiness.
          </p>
        </motion.div>

        {/* Regional */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="flex flex-col bg-white p-8 rounded-xl border border-line shadow-sm" data-id="element-342">
          <div className="flex items-center gap-3 mb-4 border-b border-line pb-4" data-id="element-343">
            <Map size={24} className="text-teal" data-id="element-344" />
            <h3 className="text-xl font-heading font-bold text-ink-dark" data-id="element-345">
              Regional / Provincial
            </h3>
          </div>
          <p className="text-ink-muted leading-relaxed" data-id="element-346">
            Support education reform, workforce planning, resilience strategy,
            and leadership development across broader populations.
          </p>
        </motion.div>

        {/* National */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex flex-col bg-white p-8 rounded-xl border border-line shadow-sm" data-id="element-347">
          <div className="flex items-center gap-3 mb-4 border-b border-line pb-4" data-id="element-348">
            <Globe2 size={24} className="text-navy" data-id="element-349" />
            <h3 className="text-xl font-heading font-bold text-ink-dark" data-id="element-350">
              National
            </h3>
          </div>
          <p className="text-ink-muted leading-relaxed" data-id="element-351">
            Support ministry-level planning, civil-service modernization,
            executive readiness, and strategic capability mapping.
          </p>
        </motion.div>
      </div>
    </section>;
}